import { render, staticRenderFns } from "./SortView.vue?vue&type=template&id=476c5b98"
import script from "./SortView.vue?vue&type=script&lang=js"
export * from "./SortView.vue?vue&type=script&lang=js"
import style0 from "./SortView.vue?vue&type=style&index=0&id=476c5b98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports